import React, { useState, useEffect } from 'react';
import { uploadDocument, fetchStates } from '../services/api';
import LayoutWithNavbar from './LayoutWithNavbar';

const UploadDocuments = () => {
  const [file, setFile] = useState(null);
  const [docType, setDocType] = useState('');
  const [stateId, setStateId] = useState('');
  const [states, setStates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [failedRows, setFailedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const loadStates = async () => {
    const res = await fetchStates();
    if (res.success) setStates(res.data);
    else alert(res.message);
  };

  useEffect(() => {
    loadStates();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file || !docType || !stateId) {
      return alert('All fields are required');
    }
  
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', docType);
    formData.append('state', stateId);
  
    setLoading(true);
    const res = await uploadDocument(formData);
    console.log(res,"res")
    setLoading(false);
    if (res.data?.failed_rows?.length) {
      console.log()
      setFailedRows(res.data.failed_rows);
      setShowModal(true);
    } else if (res.success) {
      alert(res.data.message || 'Uploaded successfully');
      setFile(null);
      setDocType('');
      setStateId('');
      window.location.reload();
    } else {
      alert(res.message || 'Upload failed');
    }
  };
  

  return (
    <LayoutWithNavbar>
      <div style={styles.page}>
        <div style={styles.container}>
          <h2 style={styles.title}>Upload Documents</h2>
          <form onSubmit={handleSubmit} style={styles.form}>
            <input type="file" onChange={(e) => setFile(e.target.files[0])} style={styles.input} />
            <select value={docType} onChange={(e) => setDocType(e.target.value)} style={styles.input}>
              <option value="">Select Document Type</option>
              <option value="invoice">ITC</option>
              <option value="form2b">Form2B</option>
              <option value="creditnote">Credit Note</option>
              <option value="debitnote">Debit Note</option>

            </select>
            <select value={stateId} onChange={(e) => setStateId(e.target.value)} style={styles.input}>
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.statename} value={state.statename}>
                  {state.statename}
                </option>
              ))}
            </select>
            <button type="submit" style={styles.button} disabled={loading}>
              {loading ? 'Uploading...' : 'Submit'}
            </button>
          </form>

          {loading && (
            <div style={styles.loaderOverlay}>
              <div className="spinner" style={styles.spinner}></div>
              <p style={styles.loadingText}>Uploading file, please wait...</p>
            </div>
          )}
        </div>

        {showModal && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <h3 style={styles.modalTitle}>Upload Completed with Errors</h3>
              <div style={styles.tableWrapper}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Row Number</th>
                      <th style={styles.th}>Error Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {failedRows.map((row, idx) => (
                      <tr key={idx} style={styles.tr}>
                        <td style={styles.td}>{row.row_index}</td>
                        <td style={styles.td}>{row.error}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button onClick={() => setShowModal(false)} style={styles.closeButton}>Close</button>
            </div>
          </div>
        )}
      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  page: {
    height: '80vh',
    backgroundColor: '#f0f2f5',
    padding: '30px 20px',
    boxSizing: 'border-box'
  },
  container: {
    maxWidth: '800px',
    maxHeight:'800px',
    margin: '0 auto',
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    position: 'relative',
  },
  title: {
    marginBottom: '20px',
    fontSize: '32px',
    fontWeight:'bold',
    textAlign: 'center',
    color: '#333'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px'
  },
  input: {
    padding: '18px',
    borderRadius: '6px',
    fontSize: '18px',
    fontWeight:'500',
    border: '1px solid #ccc'
  },
  button: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    padding: '14px',
    fontSize: '18px',
    fontWeight:'500',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  loaderOverlay: {
    position: 'absolute',
    top: 0, left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.8)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px'
  },
  spinner: {
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #007bff',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite'
  },
  loadingText: {
    marginTop: '10px',
    fontSize: '16px',
    color: '#555'
  },
  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '25px',
    width: '90%',
    maxWidth: '850px',
    boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
    maxHeight: '85vh',
    overflow: 'hidden'
  },
  modalTitle: {
    marginBottom: '20px',
    fontSize: '22px',
    textAlign: 'center',
    fontWeight: '600',
    color: '#111'
  },
  tableWrapper: {
    maxHeight: '420px',
    overflowY: 'auto',
    borderRadius: '8px',
    border: '1px solid #ddd'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '16px'
  },
  th: {
    backgroundColor: '#007bff',
    color: 'white',
    fontWeight: '800',
    padding: '12px',
    textAlign: 'left',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    borderBottom: '2px solid #ccc'
  },
  tr: {
    borderBottom: '1px solid #eee'
  },
  td: {
    padding: '12px',
    color: '#333',
    fontWeight: '600',
    borderBottom: '1px solid #ddd'
  },
  closeButton: {
    marginTop: '20px',
    padding: '12px 20px',
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontWeight: 'bold',
    cursor: 'pointer'
  }
};

export default UploadDocuments;
